import axios from 'axios';
import { useAuthStore } from './auth';

function deriveBaseURL() {
  const explicit = import.meta.env.VITE_API_URL;
  if (explicit) return explicit;
  if (typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.hostname}:8000`;
  }
  return 'http://localhost:8000';
}

const baseURL = deriveBaseURL();

export const api = axios.create({ baseURL, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    if (status === 401 && !original._retried) {
      original._retried = true;
      try {
        if (!refreshing) {
          const { refreshToken } = useAuthStore.getState();
          if (!refreshToken) throw new Error('no refresh token');
          refreshing = axios
            .post(`${baseURL}/api/v1/auth/refresh/`, { refresh: refreshToken })
            .then((r) => {
              useAuthStore.getState().setTokens({
                access: r.data.access,
                refresh: r.data.refresh ?? refreshToken,
              });
              return r.data.access;
            })
            .finally(() => { refreshing = null; });
        }
        const newAccess = await refreshing;
        original.headers.Authorization = `Bearer ${newAccess}`;
        return api(original);
      } catch {
        useAuthStore.getState().logout();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);
